import { environment } from '../../environments/environment';
import { AppConsts } from '../AppConsts';

export const GetRemoteGnomServiceBaseUrl = (): string => environment.remoteGnomServiceBaseUrl;

export const GetRemoteServiceBaseUrl = (): string => AppConsts.remoteServiceBaseUrl;
